import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/UserLogin.vue';
import Dashboard from '../components/UserDashboard.vue';
import DataOverview from '../components/DataOverview.vue';
import BraceletManagement from '../components/BraceletManagement.vue';
import BaseStations from '../components/BaseStations.vue';
import TagManagement from '../components/TagManagement.vue';
import NotificationSystem from '../components/NotificationSystem.vue';

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/dashboard',
    component: Dashboard,
    redirect: '/dashboard/overview',
    children: [
      {
        path: 'overview',
        component: DataOverview
      },
      {
        path: 'bracelets',
        component: BraceletManagement
      },
      {
        path: 'base-stations',
        component: BaseStations
      },
      {
        path: 'tags',
        component: TagManagement
      },
      {
        path: 'notifications',
        component: NotificationSystem
      },
      {
        path: 'map-management',
        component: () => import('../components/MapManagement.vue')
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
